import css from './index.module.scss';
import KlaviyoForm from '@/components/SignUpForm/Klaviyo';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import { getCurrTemplate } from '../../EmailDataMap';
import Popup from '../../Popup';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/h5/');

export default function Comp() {
    const { useEffect, useState, useLang, useRouter, useRef, gtm } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const [isEnter, setIsEnter] = useState(false);
    const { locale } = useRouter();
    const signUpEmail = getCurrTemplate(locale);
    const [openPopup, setOpenPopup] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        setIsEnter(true);
    }, []);

    return (
        <div
            className={`${css.homeVideo} ${isEnter ? 'isEnter' : ''} homeVideo GtmModuleData-section`}
            data-section-id={css.homeVideo}
            data-section-title={t('delta2.title')}
        >
            <div className="img-item">
                <EFPic name={[`kv${locale === 'jp' ? 'jp' : ''}.webp`, `kv${locale === 'jp' ? 'jp' : ''}.jpg`]} />
            </div>
            <div className="v-msg">
                <div className="v-msg-1">{t('delta2.title')}</div>
                <div className="v-msg-2">{t('delta2.title2')}</div>
            </div>
            {signUpEmail.type && (
                <div className="email-box">
                    <div className="v-msg-0">{t('delta2.title_add')}</div>
                    <div className="v-msg-3">{t('delta2.email_msg_new')}</div>
                    {locale === 'za' && signUpEmail.type && <div className="more">{t('delta2.sec1_more')}</div>}
                    <div className="email-wrapper">
                        {signUpEmail.type === 'mailchimp' && (
                            <Mailchimp
                                scriptUrl={signUpEmail.scriptUrl}
                                successCallback={() => {
                                    setOpenPopup(true);
                                    ref?.current?.resetFiled();
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'activity_submit',
                                        button_name: 'get_preview',
                                        status: 'success',
                                    });
                                    window?.fbq && window?.fbq('track', 'Lead');
                                }}
                                errorCallback={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'activity_submit',
                                        button_name: 'get_preview',
                                        status: 'fail',
                                    });
                                }}
                            >
                                <signUpEmail.Component ref={ref} action={signUpEmail.action} extraFields={signUpEmail.extraFields} />
                            </Mailchimp>
                        )}
                        {signUpEmail.type === 'klaviyo' && (
                            <KlaviyoForm
                                extra_properties={{
                                    $source: signUpEmail.source,
                                    $method_type: 'Klaviyo Form',
                                    $method_id: 'embed',
                                    $consent_version: 'Embed default text',
                                }}
                                successCallback={() => {
                                    setOpenPopup(true);
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'activity_submit',
                                        button_name: 'get_preview',
                                        status: 'success',
                                    });
                                    window?.fbq && window?.fbq('track', 'Lead');
                                }}
                                errorCallback={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'activity_submit',
                                        button_name: 'get_preview',
                                        status: 'fail',
                                    });
                                }}
                            >
                                <signUpEmail.Component list_id={signUpEmail.list_id} />
                            </KlaviyoForm>
                        )}
                    </div>
                </div>
            )}

            <Popup visible={openPopup} onCancel={() => setOpenPopup(false)} />
        </div>
    );
}
